var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"error",attrs:{"type":"error"}},[_c('ul',{staticClass:"alert alert-danger"},_vm._l((_vm.errors),function(value,key){return _c('li',{key:key},[_vm._v(" "+_vm._s(value)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }